import { connect } from "react-redux"
import { Dispatch } from "redux"
import { RootState, ReduxAction } from "../../../../reducers"
import { Visiblity } from "../../../../rpcs/dist/EpisodeRPC"
import { ActionDispatcher } from "../../actiondispacher/action-dispacher"

export interface IContainerProps {
  actions: ActionDispatcher
  visibility: Visiblity
  isSending: boolean
}

const mapStateToProps = ({
  pages,
}: RootState): Omit<IContainerProps, "actions"> => ({
  visibility: pages.editor.fetchData.episode!.visiblity,
  isSending: pages.editor.currentEditingState.isSending,
})

const mapDispatchToProps = (dispatch: Dispatch<ReduxAction>) => ({
  actions: new ActionDispatcher(dispatch),
})

export const container = connect(mapStateToProps, mapDispatchToProps)
